import React, { useState, useEffect } from "react";
import style from "./index.module.scss";
import cn from "classnames";
import ToggleSwitchIcon from "../../shared/icons/ToggleSwitchIcon";

const CustomSwitch = ({ onToggle, defaultValue }) => {
  const [isChecked, setIsChecked] = useState(defaultValue || false);

  useEffect(() => {
    setIsChecked(defaultValue || false);
  }, [defaultValue]);

  const handleToggle = () => {
    setIsChecked(!isChecked);
    onToggle(!isChecked);
  };

  return (
    <div className={style.switch} onClick={handleToggle}>
      {isChecked ? <ToggleSwitchIcon type={1} /> : <ToggleSwitchIcon type={0} />}
    </div>
  );
};

export default CustomSwitch;
